export default function CtaBand() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 pb-14 md:pb-20">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-accent-400/30 blur-2xl pointer-events-none"></div>
          <div className="absolute -left-12 -bottom-10 w-52 h-52 rounded-full bg-primary-700/40 blur-2xl pointer-events-none"></div>

          <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">
                准备好安装蘑菇视频了吗？
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-50/85 leading-relaxed">
                下载最新版本安装包，按照页面步骤操作，一两分钟即可完成安装并开始使用。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                获取安卓版
              </a>
              <a
                href="#steps"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看安装教程
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}